import * as type from '@app/constants/myEnergy/myEnergy'

export const chooseTab = (chosenTab: string) => ({
  type: type.CHOOSE_TAB,
  chosenTab,
})
